import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { getIsSignedIn } from './modules/selectors'
import { listenAuthState } from './modules/app'

const Auth = ({ children }) => {
  const dispatch = useDispatch()
  const selector = useSelector((state) => state)
  const isSingedIn = getIsSignedIn(selector)

  useEffect(() => {
    if (!isSingedIn) {
      dispatch(listenAuthState())
    }
  })

  if (!isSingedIn) {
    return <div> Loading ... </div>
  } else {
    return children
  }
}

export default Auth
